import React, {useState} from "react";
import {CheckOutlined, ExclamationCircleOutlined, StopOutlined} from "@ant-design/icons";
import {Alert, Button, Dropdown, Input, Menu, Popconfirm, Row, message} from "antd";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {useTranslation} from "react-i18next";
import {ActionButton} from "./CourierOnboardingActionButtons.styles";
import "./CourierOnboardingActionButtons.css";
const MIN_REJECT_REASON_LENGTH = 15;
export const CourierOnboardingActionButtons = ({
    courier,
    courierLoading = true,
    reloadCourier,
    isTabActive
}) => {
    const stores = useStore();
    const {t} = useTranslation();
    const [updateCourierStatusLoading, setUpdateCourierStatusLoading] = useState(false);
    const [onboardingDocumentRejectReason, setOnboardingDocumentRejectReason] = useState("");
    const [blockReason, setBlockReason] = useState("");
    const [applicationRejectReason, setApplicationRejectReason] = useState("");

    const [documentsProgressResultLoading, documentsProgressResult] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.getDocumentsProgress.bind(null, {
            courierId: courier?._id.toString()
        }),
        dependencies: [isTabActive, courierLoading],
        initialCall: isTabActive,
        condition: isTabActive && !courierLoading
    });

    const approveOnboardingDocumentVerificationStatus = async () => {
        setUpdateCourierStatusLoading(true);
        try {
            await stores.courierStore.approveOnboardingDocumentVerificationStatus({
                courierId: courier?._id.toString()
            });
            reloadCourier();
        } catch (e) {
            console.error(e);
        } finally {
            setUpdateCourierStatusLoading(false);
        }
    };

    const rejectOnboardingDocumentVerificationStatus = async () => {
        if (!onboardingDocumentRejectReason) {
            message.error("Lütfen reddetme sebebini giriniz.");
            return;
        }
        if (onboardingDocumentRejectReason?.trim()?.length < MIN_REJECT_REASON_LENGTH) {
            message.error(
                `Lütfen reddetme sebebini en az ${MIN_REJECT_REASON_LENGTH} karakter olacak şekilde giriniz.`
            );
            return;
        }
        setUpdateCourierStatusLoading(true);
        try {
            await stores.courierStore.rejectOnboardingDocumentVerificationStatus({
                courierId: courier?._id.toString(),
                onboardingRejectReason: onboardingDocumentRejectReason || ""
            });
            reloadCourier();
        } catch (e) {
            console.error(e);
        } finally {
            setOnboardingDocumentRejectReason("");
            setUpdateCourierStatusLoading(false);
        }
    };

    const blockCourier = async () => {
        if (!blockReason) {
            message.error("Lütfen kara listeye alma sebebini giriniz.");
            return;
        }
        if (blockReason?.trim()?.length < MIN_REJECT_REASON_LENGTH) {
            message.error(
                `Lütfen kara listeye alma sebebini en az ${MIN_REJECT_REASON_LENGTH} karakter olacak şekilde giriniz.`
            );
            return;
        }
        setUpdateCourierStatusLoading(true);
        try {
            await stores.courierStore.blockCourier({
                courierId: courier?._id.toString(),
                reason: blockReason || ""
            });
            reloadCourier();
        } catch (e) {
            console.error(e);
        } finally {
            setBlockReason("");
            setUpdateCourierStatusLoading(false);
        }
    };

    const unblockCourier = async () => {
        if (!blockReason) {
            message.error("Lütfen kara listeden çıkarma sebebini giriniz.");
            return;
        }
        if (blockReason?.trim()?.length < MIN_REJECT_REASON_LENGTH) {
            message.error(
                `Lütfen kara listeden çıkarma sebebini en az ${MIN_REJECT_REASON_LENGTH} karakter olacak şekilde giriniz.`
            );
            return;
        }
        setUpdateCourierStatusLoading(true);
        try {
            await stores.courierStore.unblockCourier({
                courierId: courier?._id.toString(),
                reason: blockReason || ""
            });
            reloadCourier();
        } catch (e) {
            console.error(e);
        } finally {
            setBlockReason("");
            setUpdateCourierStatusLoading(false);
        }
    };

    const rejectCourierApplication = async () => {
        if (!applicationRejectReason) {
            message.error("Lütfen olumsuz olarak işaretleme sebebini giriniz.");
            return;
        }
        if (applicationRejectReason?.trim()?.length < MIN_REJECT_REASON_LENGTH) {
            message.error(
                `Lütfen olumsuz olarak işaretleme sebebini en az ${MIN_REJECT_REASON_LENGTH} karakter olacak şekilde giriniz.`
            );
            return;
        }
        setUpdateCourierStatusLoading(true);
        try {
            await stores.courierStore.rejectCourierApplication({
                courierId: courier?._id.toString(),
                reason: applicationRejectReason || ""
            });
            reloadCourier();
        } catch (e) {
            console.error(e);
        } finally {
            setApplicationRejectReason("");
            setUpdateCourierStatusLoading(false);
        }
    };

    const undoCourierRejection = async () => {
        if (!applicationRejectReason) {
            message.error("Lütfen olumsuz işaretleme geri alma sebebini giriniz.");
            return;
        }
        if (applicationRejectReason?.trim()?.length < MIN_REJECT_REASON_LENGTH) {
            message.error(
                `Lütfen olumsuz işaretleme geri alma sebebini en az ${MIN_REJECT_REASON_LENGTH} karakter olacak şekilde giriniz.`
            );
            return;
        }
        setUpdateCourierStatusLoading(true);
        try {
            await stores.courierStore.undoCourierRejection({
                courierId: courier?._id.toString(),
                reason: applicationRejectReason || ""
            });
            reloadCourier();
        } catch (e) {
            console.error(e);
        } finally {
            setApplicationRejectReason("");
            setUpdateCourierStatusLoading(false);
        }
    };

    /* if (courierLoading || !courier) {
        return <div>Yükleniyor...</div>;
    } */
    const checkPermission = key => {
        const onboardingStatus = courier?.onboardingStatus;
        const onboardingSubStatus = courier?.onboardingSubStatus;
        const onboardingStep = courier?.onboardingStep;

        const permissions = {
            viewApproveOnboardingDocumentVerification:
                !stores.meStore.checkRole("isCompanyUser") &&
                onboardingStatus === "candidateCandidate",

            viewOnboardingDocumentRejectButton:
                !stores.meStore.checkRole("isCompanyUser") && !documentsProgressResultLoading,

            viewBlackListButton:
                !stores.meStore.checkRole("isCompanyUser") &&
                !documentsProgressResultLoading &&
                courier?.onboardingStatus !== "blocked",

            viewRemoveFromBlackListButton:
                !stores.meStore.checkRole("isCompanyUser") &&
                !documentsProgressResultLoading &&
                courier?.onboardingStatus === "blocked",

            viewOnboardingDocumentApproveButton: !stores.meStore.checkRole("isCompanyUser"),

            viewCourierApplicationRejectButton:
                !stores.meStore.checkRole("isCompanyUser") &&
                !documentsProgressResultLoading &&
                !courier?.isApplicationRejected,

            viewUndoCourierRejectionButton:
                !stores.meStore.checkRole("isCompanyUser") &&
                !documentsProgressResultLoading &&
                courier?.isApplicationRejected,

            blockCourier:
                !stores.meStore.checkRole("isCompanyUser") &&
                !documentsProgressResultLoading &&
                courier?.onboardingStatus !== "blocked",
            rejectCourierApplication:
                !stores.meStore.checkRole("isCompanyUser") &&
                !documentsProgressResultLoading &&
                courier?.onboardingStatus !== "blocked" &&
                !Boolean(courier?.isApplicationRejected),

            approveOnboardingDocumentVerification:
                !stores.meStore.checkRole("isCompanyUser") &&
                onboardingSubStatus === "documentsInReview" &&
                !documentsProgressResultLoading &&
                documentsProgressResult?.isReadyToApprove,
            rejectOnboardingDocumentVerification:
                !stores.meStore.checkRole("isCompanyUser") &&
                onboardingSubStatus === "documentsInReview" &&
                !documentsProgressResultLoading &&
                documentsProgressResult?.isReadyToRejectDocuments
        };

        return permissions?.[key] || false;
    };

    const renderBlackListButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    <h3>
                        <b>Kara Listeye Al</b>
                    </h3>
                    <p>Kuryeyi kara listeye almak istediğinize emin misiniz? </p>
                    <p>
                        Bu işlem yapıldıktan sonra; kurye ya da Vigo Yetkilisi, ilgili kurye kaydı
                        üzerinde herhangi bir işlem yapamayacaktır.
                    </p>
                    <p>Lütfen kuryenin neden kara listeye alındığını belirtin.</p>
                    <Input.TextArea
                        placeholder="Kara listeye alma nedenini giriniz."
                        style={{marginTop: "10px"}}
                        value={blockReason}
                        onChange={e => {
                            setBlockReason(e.target.value);
                        }}
                        rows={4}
                    />
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => blockCourier()}
            okText={"Onayla"}
            cancelText={"İptal"}
            okButtonProps={{disabled: !blockReason}}
            disabled={!checkPermission("blockCourier")}
        >
            <Button
                loading={updateCourierStatusLoading}
                type="primary "
                style={{
                    backgroundColor: "#000000",
                    borderColor: "#000000",
                    color: "white",
                    opacity: !checkPermission("blockCourier") ? 0.5 : 1
                }}
                //icon={<StopOutlined />}
                disabled={!checkPermission("blockCourier")}
            >
                {courier?.onboardingStatus === "blocked"
                    ? "Kara Listeye Alınmış"
                    : "Kara Listeye Al"}
            </Button>
        </Popconfirm>
    );
    const renderRemoveFromBlackListButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    <h3>
                        <b>Kara Listeden Çıkart</b>
                    </h3>
                    <p>Kuryeyi kara listeden çıkarmak istediğinize emin misiniz? </p>
                    <p>
                        Bu işlem yapıldıktan sonra; Vigo Yetkilileri, ilgili kurye kaydı üzerinde
                        işlem yapabilir duruma gelecektir.
                    </p>
                    <p>Kurye, kaldığı yerden işlemlerine devam edebilecektir.</p>
                    <p>Lütfen kuryenin neden kara listeden çıkarıldığını belirtin.</p>
                    <Alert
                        style={{padding: "5px"}}
                        message={
                            <span style={{fontWeight: "bold", fontSize: "14px"}}>
                                Kara Listeye Alınma Sebebi :
                            </span>
                        }
                        description={courier?.onboardingRejectReason || ""}
                        type="warning"
                    />
                    <Input.TextArea
                        placeholder="Kurye kara listeden çıkarılma nedenini giriniz."
                        style={{marginTop: "10px"}}
                        value={blockReason}
                        onChange={e => {
                            setBlockReason(e.target.value);
                        }}
                        rows={4}
                    />
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => unblockCourier()}
            okText={"Onayla"}
            cancelText={"İptal"}
            okButtonProps={{disabled: !blockReason}}
            disabled={!checkPermission("viewRemoveFromBlackListButton")}
        >
            <Button
                loading={updateCourierStatusLoading}
                type="primary "
                style={{
                    opacity: !checkPermission("viewRemoveFromBlackListButton") ? 0.5 : 1
                }}
                disabled={!checkPermission("viewRemoveFromBlackListButton")}
            >
                {courier?.onboardingStatus === "blocked"
                    ? "Kara Listeden Çıkarma"
                    : "Kara Listeye Alınmış"}
            </Button>
        </Popconfirm>
    );
    const renderApplicationRejectButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    <h3>
                        <b>Olumsuz</b>
                    </h3>
                    <p>
                        Kuryenin başvurusunu olumsuz olarak işaretlemek istediğinize emin misiniz?{" "}
                    </p>
                    <p>Bu işlemi yaptığınızda; kurye kaydı, olumsuz olarak işaretlenecektir.</p>
                    <p>
                        Kurye, tekrar giriş yaptığında ya da belgelerini işe alımcı onayına
                        gönderdiğinde olumsuz olarak işaretlenme durumu kalkacaktır.
                    </p>
                    <p>Lütfen kurye başvurusunu olumsuz olarak işaretleme nedenini belirtin.</p>
                    <Input.TextArea
                        placeholder="Kurye başvurusunu olumsuz olarak işaretleme nedenini giriniz."
                        style={{marginTop: "10px"}}
                        value={applicationRejectReason}
                        onChange={e => {
                            setApplicationRejectReason(e.target.value);
                        }}
                        rows={4}
                    />
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => rejectCourierApplication()}
            onVisibleChange={() => {
                setApplicationRejectReason("");
            }}
            okText={"Onayla"}
            cancelText={"İptal"}
            okButtonProps={{disabled: !applicationRejectReason}}
            disabled={!checkPermission("rejectCourierApplication")}
        >
            <Button
                loading={updateCourierStatusLoading}
                type="primary "
                style={{
                    backgroundColor: "#a52b2b",
                    borderColor: "#a52b2b",
                    color: "white",
                    opacity: !checkPermission("rejectCourierApplication") ? 0.5 : 1
                }}
                //icon={<StopOutlined />}
                disabled={!checkPermission("rejectCourierApplication")}
            >
                {courier?.isApplicationRejected ? "Olumsuz İşaretlenmiş" : "Olumsuz"}
            </Button>
        </Popconfirm>
    );
    const renderUndoCourierRejectionButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    <h3>
                        <b>Olumsuz İşaretlenmesini Geri Al</b>
                    </h3>
                    <p>
                        Kurye başvurusunun olumsuz olarak işaretlenmesini geri almak istediğinize
                        emin misiniz?{" "}
                    </p>
                    <p>
                        Bu işlemi yaptığınızda; kurye kaydının, olumsuz olarak işaretlenme durumu
                        kalkacaktır.
                    </p>
                    <p>
                        Lütfen kurye başvurusunun olumsuz olarak işaretlenmesini geri alma nedenini
                        belirtin.
                    </p>
                    <Alert
                        style={{padding: "5px"}}
                        message={
                            <span style={{fontWeight: "bold", fontSize: "14px"}}>
                                Olumsuz İşaretlenme Sebebi :
                            </span>
                        }
                        description={courier?.onboardingRejectReason || ""}
                        type="warning"
                    />
                    <Input.TextArea
                        placeholder="Kurye başvurusunun olumsuz olarak işaretlenmesini geri alma nedenini giriniz."
                        style={{marginTop: "10px"}}
                        value={applicationRejectReason}
                        onChange={e => {
                            setApplicationRejectReason(e.target.value);
                        }}
                        rows={4}
                    />
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => undoCourierRejection()}
            okText={"Onayla"}
            cancelText={"İptal"}
            okButtonProps={{disabled: !applicationRejectReason}}
            disabled={!checkPermission("viewUndoCourierRejectionButton")}
        >
            <Button
                loading={updateCourierStatusLoading}
                type="primary "
                style={{
                    /*  backgroundColor: "#a52b2b",
                        borderColor: "#a52b2b",
                    color: "white", */
                    opacity: !checkPermission("viewUndoCourierRejectionButton") ? 0.5 : 1
                }}
                //icon={<StopOutlined />}
                disabled={!checkPermission("viewUndoCourierRejectionButton")}
            >
                {courier?.isApplicationRejected
                    ? "Olumsuz İşaretlenmesini Geri Al"
                    : "Olumsuz İşaretlenmemiş"}
            </Button>
        </Popconfirm>
    );
    const renderBlockButtonGroup = () => (
        <Dropdown
            overlay={
                <Menu>
                    {checkPermission("viewCourierApplicationRejectButton") && (
                        <Menu.Item>{renderApplicationRejectButton()}</Menu.Item>
                    )}
                    {checkPermission("viewUndoCourierRejectionButton") && (
                        <Menu.Item>{renderUndoCourierRejectionButton()}</Menu.Item>
                    )}
                    {checkPermission("viewBlackListButton") && (
                        <Menu.Item>{renderBlackListButton()}</Menu.Item>
                    )}
                    {checkPermission("viewRemoveFromBlackListButton") && (
                        <Menu.Item>{renderRemoveFromBlackListButton()}</Menu.Item>
                    )}
                </Menu>
            }
            trigger={"click"}
        >
            <ActionButton
                style={{
                    backgroundColor: "#a52b2b",
                    borderColor: "#a52b2b",
                    color: "white"
                }}
                icon={<StopOutlined />}
            >
                Kalıcı Red Aksiyonları
            </ActionButton>
        </Dropdown>
    );
    const renderRejectButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    <h4>
                        <b>Belge/Bilgi Güncelleme Talebi</b>
                    </h4>
                    <p>Kuryeden, belge/bilgi güncelleme istediğinize emin misiniz? </p>
                    <p>
                        Bu işlemi yaptığınızda;
                        <br /> kurye, belge ve bilgilerini tekrardan güncelleyebilecektir.
                    </p>
                    <p>
                        Kurye adayına geri bildirim vermek için lütfen belge kontrol sürecini neden
                        belge/bilgi güncelleme istediğinizi belirtin.
                    </p>
                    <b>
                        Kurye, tekrardan döküman kontrolü talep edene kadar işlem yapamayacaksınız.
                    </b>
                    <Input.TextArea
                        placeholder="Kuryeye sms ve mail olarak gönderilecek olan belge/bilgi güncelleme nedenini giriniz."
                        style={{marginTop: "10px"}}
                        value={onboardingDocumentRejectReason}
                        onChange={e => {
                            setOnboardingDocumentRejectReason(e.target.value);
                        }}
                        rows={4}
                    />
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => rejectOnboardingDocumentVerificationStatus()}
            okText={"Onayla"}
            cancelText={"İptal"}
            okButtonProps={{disabled: !onboardingDocumentRejectReason}}
            disabled={!checkPermission("rejectOnboardingDocumentVerification")}
            trigger={"click"}
        >
            <ActionButton
                loading={updateCourierStatusLoading}
                type="default"
                icon={<ExclamationCircleOutlined />}
                disabled={!checkPermission("rejectOnboardingDocumentVerification")}
            >
                Belge/Bilgi Güncelleme İste
            </ActionButton>
        </Popconfirm>
    );

    const renderApproveButton = () => (
        <Popconfirm
            placement="bottomLeft"
            icon={null}
            title={
                <>
                    Kuryeye ait belgelerin ve bilgilerin doğru olduğundan emin olun.
                    <br />
                    <br /> Kuryeye, belge kontrol onayı verildikten sonra; kurye proje seçimi
                    adımına geçecektir.
                    <br />
                    <br /> <b>Bu işlem, şu an için geri alınamaz.</b>
                </>
            }
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={() => approveOnboardingDocumentVerificationStatus()}
            okText={"Onayla"}
            cancelText={"İptal"}
            disabled={!checkPermission("approveOnboardingDocumentVerification")}
        >
            <ActionButton
                loading={updateCourierStatusLoading}
                type="primary"
                disabled={!checkPermission("approveOnboardingDocumentVerification")}
            >
                <CheckOutlined /> Tüm Bilgileri Onayla
            </ActionButton>
        </Popconfirm>
    );

    return (
        <Row style={{rowGap: "8px", columnGap: "8px"}}>
            {renderBlockButtonGroup()}
            {checkPermission("viewApproveOnboardingDocumentVerification") ? (
                <>
                    {checkPermission("viewOnboardingDocumentRejectButton") && renderRejectButton()}
                    {checkPermission("viewOnboardingDocumentApproveButton") &&
                        renderApproveButton()}
                </>
            ) : (
                <> </>
            )}
        </Row>
    );
};
